import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import * as Yup from 'yup';
import { Reminder } from '../models/reminder';
import { ReminderService } from '../services/reminder.service';
import { UploadService } from '../services/upload.service';

interface IState {
    reminder: Reminder;
    isLoading: boolean;
    isUploading: boolean;
    isEdit: boolean;
}

export class ReminderEditPage extends React.Component<any, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            reminder: new Reminder(),
            isLoading: false,
            isUploading: false,
            isEdit: false
          };
    }

    componentDidMount() {
        let id = this.props.match.params.id ? this.props.match.params.id : 0;        

        if (id !== 0) {
          this.setState({ isLoading: true });

          ReminderService.getById(id)
            .then(
              response => {
                this.setState({
                  reminder: response,                                  
                  isLoading: false,
                  isEdit: true
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
            );
        }
    }

    uploadFile = (e, setFieldValue) => {
        this.setState({ isUploading: true });

        const file = e.target.files[0] as File;
        const formData = new FormData();
        formData.append("file", file);

        UploadService.uploadFile(formData)
            .then((responseText) => responseText)
            .catch(() => {
                this.setState({ isUploading: false });
            })
            .then((response) => {
                // set uploaded image url to data
                let newState = Object.assign({}, this.state.reminder);
                newState.image = response as string;
                setFieldValue('image', newState.image);
                this.setState({ reminder: newState, isUploading: false });
            });
    };

    render() {
        return (
            <div className="col-md-6">
                {this.state.isEdit ? 
                  <h1>Uredi podsjetnik</h1> : <h1>Kreiraj novi podsjetnik</h1>}
                {this.state.isLoading ? <SpinnerComponent /> : (
                <Formik
                    initialValues={this.state.reminder}
                    validationSchema={Yup.object().shape({
                        name: Yup.string().required('Naziv podsjetnika je potreban'),
                        image: Yup.string().required('Slika podsjetnika je potrebna'),
                        orderKey: Yup.number().required('Unesite broj za poredak'),
                        reminderTime: Yup.date().required('Datum i vrijeme podsjetnika su potrebni'),
                    })}
                    onSubmit={(values, { setStatus, setSubmitting, setError }) => {
                        setStatus();  
                        setError(null);                                     

                        // set uploaded image URL to form input value
                        values.image = this.state.reminder.image;

                        ReminderService.createOrUpdate(values)
                            .then(
                                () => {
                                    setSubmitting(false);
                                    setStatus("Uspješno spremljeno!");
                                },
                                error => {
                                    setSubmitting(false);
                                    setError(error);
                                }
                            );
                    }}
                    render={({ errors, status, touched, isSubmitting, error, setFieldValue, setStatus, setError, setSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="name">Naziv podsjetnika</label>
                                <Field name="name" type="text" className={'form-control' + (errors.name && touched.name ? ' is-invalid' : '')} />
                                <ErrorMessage name="name" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="image">Slika podsjetnika</label>
                                <Field name="reminderImage" type="file" accept="image/png, image/jpeg" 
                                       onChange={data => this.uploadFile(data, setFieldValue)} />
                            </div>
                            <div className="form-group">
                                <Field name="image" type="text" disabled className={'form-control' + (errors.image && touched.image ? ' is-invalid' : '')} />
                                <ErrorMessage name="image" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <img src={this.state.reminder.image} style={{maxHeight:200}} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="orderKey">Poredak podsjetnika (od najmanjeg broja do najvećeg)</label>
                                <Field name="orderKey" type="number" className={'form-control' + (errors.orderKey && touched.orderKey ? ' is-invalid' : '')} />
                                <ErrorMessage name="orderKey" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="reminderTime">Datum i vrijeme podsjetnika</label>
                                <Field id="reminderTime" 
                                       name="reminderTime" 
                                       type="datetime-local"                                       
                                       value={this.state.reminder.reminderTime}
                                       onChange={e => {
                                            let newState = Object.assign({}, this.state.reminder);
                                            newState.reminderTime = e.target.value;
                                            setFieldValue('reminderTime', e.target.value);
                                            this.setState({ reminder: newState });
                                        }}
                                       className={'form-control' + (errors.reminderTime && touched.reminderTime ? ' is-invalid' : '')} 
                                       />
                                <ErrorMessage name="reminderTime" component="div" className="invalid-feedback" />
                            </div>
                            
                            <div className="form-group">
                                {!this.state.isUploading &&
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {this.state.isEdit ? 
                                        <span>Spremi</span> : <span>Kreiraj novi podsjetnik</span>}
                                    </button>
                                }
                                {this.state.isEdit &&
                                    <button className="btn btn-danger pull-right" disabled={isSubmitting}
                                        onClick={e => {
                                            e.preventDefault();
                                            if (window.confirm("Jeste li sigurni da želite obrisati ovaj zapis?")) {
                                                
                                                setStatus();
                                                setError(null);
                                                ReminderService.deleteById(this.state.reminder.id)
                                                .then(
                                                    () => {
                                                        setSubmitting(false);
                                                        setStatus("Uspješno obrisano!");
                                                    },
                                                    error => {
                                                        setSubmitting(false);
                                                        setError(error);
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        Izbrisati
                                    </button>
                                }  
                                {isSubmitting || this.state.isUploading &&
                                    <SpinnerComponent/>
                                }                                
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                            {status &&
                                <div className={'alert alert-success'}>{status}</div>
                            }
                        </Form>
                    )}
                />
                )}
                <button
                    className="button icon-left"
                    onClick={this.props.history.goBack}>
                    Povratak
                </button>
            </div>
        )
    }
}